// src/components/ProfileComponentInstallationInstructions.js

import style from '../ui/modals/modals.module.scss';
import { Link, useLocation } from 'react-router-dom';
import InstallationInstructions from '../installation-instructions/InstallationInstructions';
import { ROUTES, ROUTE_BUILDERS } from '../../constants/routes';
import { useCompanyConfig } from '../../hooks/useCompanyConfig';
import './EditProfileComponent.scss';
import { getText } from '../../i18n';

const ProfileComponentInstallationInstructions = () => {
    const location = useLocation();
    const loggedIn = location.state?.loggedIn ?? true;
    const { authData } = useCompanyConfig();
    const companyCode = authData?.companyCode;

    const BackNavIcon = () => (
        <i
            className="bi bi-chevron-left"
            style={{ color: '#2F2B43', paddingRight: '8px' }}
        />
    );

    const handleBackNavigation = () => {
        if (loggedIn) {
            window.location.href = ROUTES.PROFILE;
        } else {
            window.location.href =
                ROUTE_BUILDERS.loginWithCompanyCode(companyCode);
        }
    };

    return (
        <div>
            <div className="ing-edit-profile-header-main">
                {loggedIn ? (
                    <>
                        <Link to={ROUTES.PROFILE}>
                            <BackNavIcon />
                        </Link>
                    </>
                ) : (
                    <>
                        <Link
                            to={ROUTE_BUILDERS.loginWithCompanyCode(
                                companyCode,
                            )}
                        >
                            <BackNavIcon />
                        </Link>
                    </>
                )}

                {getText('msg_ad0bb58de6ed')}
            </div>
            <div
                className={`modal-body text-center ${style.modalBody}`}
                style={{ marginTop: '20px', padding: '21px' }}
            >
                <p
                    style={{
                        fontSize: '16px',
                        color: '#667085',
                        textAlign: 'left',
                    }}
                >
                    {getText('msg_8bb6a107b1a5')} sdsccsd
                </p>
                <InstallationInstructions />
            </div>
        </div>
    );
};

export default ProfileComponentInstallationInstructions;
